import MuiPhoneNumber from 'material-ui-phone-number'
import {CreateAgreementStep3DataType, signerDataType, witnessDataType} from '../agreementDataType'

const CreateAgreementStep3 = ({
  formik,
  signers,
  setSigners,
  witness,
  setWitness,
}: CreateAgreementStep3DataType) => {
  // function to add signer
  const handleAddSigner = () => {
    setSigners((prevSigners: signerDataType[]) => [
      ...prevSigners,
      {
        name: '',
        identifier: '',
        identifier_type: 'email',
        sign_type: '',
        reason: '',
      },
    ])
    formik.setFieldValue(
      `signers`,
      [
        ...formik.values.signers,
        {
          name: '',
          identifier: '',
          identifier_type: 'email',
          sign_type: '',
          reason: '',
        },
      ],
      true
    )
  }

  // function to delete the signer
  const handleDeleteSigner = (i: number) => {
    setSigners((prevSigners: signerDataType[]) =>
      prevSigners.filter((_, index: number) => index !== i)
    )
    const updatedArray = formik.values.signers.filter((_: any, index: number) => index !== i)
    formik.setFieldValue(`signers`, updatedArray, true)
  }

  // function to add witness
  const handleAddWitness = () => {
    setWitness((prevWitness: witnessDataType[]) => [
      ...prevWitness,
      {
        name: '',
        identifier: '',
        identifier_type: 'email',
        sign_type: '',
        reason: '',
      },
    ])
    formik.setFieldValue(
      `witness`,
      [
        ...formik.values.witness,
        {
          name: '',
          identifier: '',
          identifier_type: 'email',
          sign_type: '',
          reason: '',
        },
      ],
      true
    )
  }

  // function to delete witness
  const handleDeleteWitness = (i: number) => {
    setWitness((prevWitness: witnessDataType[]) =>
      prevWitness.filter((_, index: number) => index !== i)
    )
    const updatedArray = formik.values.witness.filter((_: any, index: number) => index !== i)
    formik.setFieldValue(`witness`, updatedArray, true)
  }

  // function to change signer identifier
  const changeSignerIdentifier = (val: string, index: number) => {
    setSigners([
      ...signers.slice(0, index),
      {...signers[index], identifier_type: val},
      ...signers.slice(index + 1),
    ])
    formik.setFieldValue(`signers[${index}].identifier`, '', true)
    formik.setFieldValue(`signers[${index}].identifier_type`, val, true)
  }

  // function to change witness identifier
  const changeWitnessIdentifier = (val: string, index: number) => {
    setWitness([
      ...witness.slice(0, index),
      {...witness[index], identifier_type: val},
      ...witness.slice(index + 1),
    ])
    formik.setFieldValue(`witness[${index}].identifier`, '', true)
    formik.setFieldValue(`witness[${index}].identifier_type`, val, true)
  }

  // Function to get the signer heading
  const returnSignerHeading = (index: number) => {
    if (formik.values.agreement_type === 'create') {
      if (index === 0) {
        return 'Lessor'
      }
      if (index === 1) {
        return 'Lessee'
      }
    } else {
      return `Signer ${index + 1}`
    }
  }
  return (
    <div className='card mb-5 mb-xl-10 w-100'>
      <div className='card-header border-0 d-flex justify-content-between align-items-center'>
        {/* Begin: Heading */}
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Signers and witness details</h3>
        </div>
        {/* End: Heading */}
      </div>

      {/* Begin: signers */}
      <div id='kt_account_profile_details' className='collapse show'>
        <div className='card-body border-top px-9 py-5 fv-row'>
          <h3 className='fw-bolder mb-4'>Signers</h3>
          <div className='row my-2'>
            {signers.map((signer: any, index: number) => {
              return (
                <div className='col-lg-6 mb-5' key={index}>
                  <div className='border border-1 border-primary border-dotted rounded p-3 px-7 position-relative'>
                    {index > 1 && (
                      <i
                        className='bi bi-x-circle-fill fs-2 position-absolute top-0 end-0 text-primary'
                        onClick={() => handleDeleteSigner(index)}
                      ></i>
                    )}
                    <div className='mb-1 '>
                      <span className='text-dark fw-bolder d-block fs-4 mb-2'>
                        {returnSignerHeading(index)}
                      </span>
                      <hr />
                      {/*Begin::Form Group Signer Name*/}
                      <div className='fv-row my-3 ml-8'>
                        <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                          <span className='required'>Name</span>
                          <i
                            className='fas fa-exclamation-circle ms-2 fs-7'
                            data-bs-toggle='tooltip'
                            title='Enter signer name'
                          ></i>
                        </label>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          name={`signers[${index}].name`}
                          placeholder='Enter signer name'
                          {...formik.getFieldProps(`signers[${index}].name`)}
                        />
                        <div className='h-20px'>
                          {formik.touched.signers &&
                            formik.touched.signers[index] &&
                            formik.touched.signers[index].name &&
                            formik.errors.signers &&
                            formik.errors.signers[index] &&
                            formik.errors.signers[index].name && (
                              <div className='fv-help-block color-red'>
                                {formik.errors.signers[index].name}
                              </div>
                            )}
                        </div>
                      </div>
                      {/*End::Form Group Signer Name*/}
                       {/*Begin::Form Group Signer email/phone button */}
                      <div className='fv-row mb-3 ml-8'>
                        <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                          <span className='required'>Get the agreement link on</span>
                          <i
                            className='fas fa-exclamation-circle ms-2 fs-7'
                            data-bs-toggle='tooltip'
                            title='Enter either signer email or signer phone number'
                          ></i>
                        </label>
                        <button
                          type='button'
                          className={`btn btn-sm fw-bold px-2 py-1 mx-1 ${
                            signer.identifier_type === 'email' ? 'btn-primary' : 'btn-secondary'
                          } `}
                          onClick={() => changeSignerIdentifier('email', index)}
                        >
                          Email Address
                        </button>

                        <button
                          type='button'
                          className={`btn btn-sm fw-bold px-2 py-1 ms-1 ${
                            signer.identifier_type === 'phone' ? 'btn-primary' : 'btn-secondary'
                          } `}
                          onClick={() => changeSignerIdentifier('phone', index)}
                        >
                          Phone Number
                        </button>
                      </div>
                      {/*Begin::Form Group Signer email/phone button */}
                      {/*Begin::Form Group Signer Email or phone fields*/}
                      {signer.identifier_type === 'email' ? (
                        <div className='fv-row mb-0 ml-8'>
                          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                            <span className='required'>Email Address</span>
                            <i
                              className='fas fa-exclamation-circle ms-2 fs-7'
                              data-bs-toggle='tooltip'
                              title='Enter signer email'
                            ></i>
                          </label>
                          <input
                            type='text'
                            className='form-control form-control-lg form-control-solid'
                            name={`signers[${index}].identifier`}
                            placeholder='Enter signer email'
                            {...formik.getFieldProps(`signers[${index}].identifier`)}
                          />
                        </div>
                      ) : (
                        <div className='fv-row mb-0'>
                          <label className='d-flex align-items-center fs-5 fw-semibold mb-2 py-1'>
                            <span className='required'>Phone Number</span>
                            <i
                              className='fas fa-exclamation-circle ms-2 fs-7'
                              data-bs-toggle='tooltip'
                              title='Enter signer phone number'
                            ></i>
                          </label>
                          <MuiPhoneNumber
                            {...formik.getFieldProps(`signers[${index}].identifier`)}
                            className='w-100 pt-2 pb-1'
                            defaultCountry={'in'}
                            onChange={(value: string) =>
                              formik.setFieldValue(`signers[${index}].identifier`, value)
                            }
                          />
                        </div>
                      )}
                      <div className='h-20px mb-3'>
                        {formik.touched.signers &&
                          formik.touched.signers[index] &&
                          formik.touched.signers[index].identifier &&
                          formik.errors.signers &&
                          formik.errors.signers[index] &&
                          formik.errors.signers[index].identifier && (
                            <div className='fv-help-block color-red'>
                              {formik.errors.signers[index].identifier}
                            </div>
                          )}
                      </div>
                        {/*End::Form Group Signer Email or phone fields*/}
                      {/*Begin::Form Group Sign Type*/}
                      <div className='fv-row mb-3 ml-8'>
                        <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                          <span className='required'>Sign Type</span>
                          <i
                            className='fas fa-exclamation-circle ms-2 fs-7'
                            data-bs-toggle='tooltip'
                            title='Enter sign type'
                          ></i>
                        </label>
                        <select
                          type='text'
                          className='form-select form-select-solid'
                          name={`signers[${index}].sign_type`}
                          placeholder='Enter sign type'
                          {...formik.getFieldProps(`signers[${index}].sign_type`)}
                        >
                          <option className='bg-color-gray' value='' disabled>
                            Select sign type
                          </option>
                          <option value='electronic'>Electronic</option>
                          <option value='aadhaar'>Aadhaar</option>
                        </select>
                        <div className='h-20px'>
                          {formik.touched.signers &&
                            formik.touched.signers[index] &&
                            formik.touched.signers[index].sign_type &&
                            formik.errors.signers &&
                            formik.errors.signers[index] &&
                            formik.errors.signers[index].sign_type && (
                              <div className='fv-help-block color-red'>
                                {formik.errors.signers[index].sign_type}
                              </div>
                            )}
                        </div>
                      </div>
                      {/*End::Form Group Sign Type*/}
                      {/*Begin::Form Group Reason*/}
                      <div className='fv-row mb-3 ml-8'>
                        <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                          <span className='required'>Reason</span>
                          <i
                            className='fas fa-exclamation-circle ms-2 fs-7'
                            data-bs-toggle='tooltip'
                            title='Enter reason'
                          ></i>
                        </label>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          name={`signers[${index}].reason`}
                          placeholder='Enter reason'
                          {...formik.getFieldProps(`signers[${index}].reason`)}
                        />
                        <div className='h-20px'>
                          {formik.touched.signers &&
                            formik.touched.signers[index] &&
                            formik.touched.signers[index].reason &&
                            formik.errors.signers &&
                            formik.errors.signers[index] &&
                            formik.errors.signers[index].reason && (
                              <div className='fv-help-block color-red'>
                                {formik.errors.signers[index].reason}
                              </div>
                            )}
                        </div>
                      </div>
                      {/*End::Form Group Reason*/}
                    </div>
                  </div>
                </div>
              )
            })}
            {/* Begin: Add signer button */}
            {
              !(formik.values.agreement_type === 'create') &&  <div className='col-lg-6 mb-5'>
              {/* <div className='d-flex flex-column align-items-center justify-content-start'> */}
              <button
                type='button'
                className={`d-flex align-items-center py-2 px-4 rounded btn ${
                  signers.length >= 4 ? 'btn-secondary' : 'btn-primary'
                }`}
                onClick={handleAddSigner}
                disabled={signers.length >= 4}
              >
                <span>
                  <i className='bi bi-plus-circle fs-2 text-light pt-2 ps-0'></i>
                </span>
                <span className='text-light'>Add more signer</span>
              </button>
              <p className='text-muted fw-bold mb-0 px-7'>{`${signers.length}/4 Signers added`}</p>
            </div>
            }
            {/* End: Add signer button */}
          </div>
        </div>
        {/* End: signers */}

        {/* Begin: Witness */}
        <div className='card-body border-top px-9 py-5 fv-row'>
          <h3 className='fw-bolder mb-4'>Witness </h3>
          <div className='row my-2'>
            {witness.map((witness: any, index: number) => {
              return (
                <div className='col-lg-6 mb-5' key={index}>
                  <div className='border border-1 border-primary border-dotted rounded p-3 px-7 position-relative'>
                    <i
                      className='bi bi-x-circle-fill fs-2 position-absolute top-0 end-0 text-primary'
                      onClick={() => handleDeleteWitness(index)}
                    ></i>
                    <div className='mb-1 '>
                      <span className='text-dark fw-bolder d-block fs-4 mb-2'>{`Witness ${
                        index + 1
                      }`}</span>
                      <hr />
                      {/*Begin::Form Group witness Name*/}
                      <div className='fv-row my-3 ml-8'>
                        <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                          <span className='required'>Name</span>
                          <i
                            className='fas fa-exclamation-circle ms-2 fs-7'
                            data-bs-toggle='tooltip'
                            title='Enter witness name'
                          ></i>
                        </label>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          name={`witness[${index}].name`}
                          placeholder='Enter witness name'
                          {...formik.getFieldProps(`witness[${index}].name`)}
                        />
                        <div className='h-20px'>
                          {formik.touched.witness &&
                            formik.touched.witness[index] &&
                            formik.touched.witness[index].name &&
                            formik.errors.witness &&
                            formik.errors.witness[index] &&
                            formik.errors.witness[index].name && (
                              <div className='fv-help-block color-red'>
                                {formik.errors.witness[index].name}
                              </div>
                            )}
                        </div>
                      </div>
                      {/*End::Form Group Witness Name*/}
                        {/*Begin::Form Group Witness Email/phone*/}
                      {/* Begin: Witness email/phone number button */}
                      <div className='fv-row mb-3 ml-8'>
                        <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                          <span className='required'>Get the agreement link on</span>
                          <i
                            className='fas fa-exclamation-circle ms-2 fs-7'
                            data-bs-toggle='tooltip'
                            title='Enter either witness email or witness phone number'
                          ></i>
                        </label>
                        <button
                          type='button'
                          className={`btn btn-sm fw-bold px-2 py-1 mx-1 ${
                            witness.identifier_type === 'email' ? 'btn-primary' : 'btn-secondary'
                          } `}
                          onClick={() => changeWitnessIdentifier('email', index)}
                        >
                          Email Address
                        </button>

                        <button
                          type='button'
                          className={`btn btn-sm fw-bold px-2 py-1 ms-1 ${
                            witness.identifier_type === 'phone' ? 'btn-primary' : 'btn-secondary'
                          } `}
                          onClick={() => changeWitnessIdentifier('phone', index)}
                        >
                          Phone Number
                        </button>
                      </div>
                      {/* End: Witness email/phone number button */}
                      {/* Begin: Witness email/phone number field */}
                      {witness.identifier_type === 'email' ? (
                        <div className='fv-row mb-0 ml-8'>
                          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                            <span className='required'>Email Address</span>
                            <i
                              className='fas fa-exclamation-circle ms-2 fs-7'
                              data-bs-toggle='tooltip'
                              title='Enter witness email'
                            ></i>
                          </label>
                          <input
                            type='text'
                            className='form-control form-control-lg form-control-solid'
                            name={`witness[${index}].identifier`}
                            placeholder='Enter witness email'
                            {...formik.getFieldProps(`witness[${index}].identifier`)}
                          />
                        </div>
                      ) : (
                        <div className='fv-row mb-0'>
                          <label className='d-flex align-items-center fs-5 fw-semibold mb-2 py-1'>
                            <span className='required'>Phone Number</span>
                            <i
                              className='fas fa-exclamation-circle ms-2 fs-7'
                              data-bs-toggle='tooltip'
                              title='Enter witness phone number'
                            ></i>
                          </label>
                          <MuiPhoneNumber
                            {...formik.getFieldProps(`witness[${index}].identifier`)}
                            className='w-100 pt-2 pb-1'
                            defaultCountry={'in'}
                            onChange={(value: string) =>
                              formik.setFieldValue(`witness[${index}].identifier`, value)
                            }
                          />
                        </div>
                      )}
                      {/* End: Witness email/phone number field */}
                      <div className='h-20px mb-3'>
                        {formik.touched.witness &&
                          formik.touched.witness[index] &&
                          formik.touched.witness[index].identifier &&
                          formik.errors.witness &&
                          formik.errors.witness[index] &&
                          formik.errors.witness[index].identifier && (
                            <div className='fv-help-block color-red'>
                              {formik.errors.witness[index].identifier}
                            </div>
                          )}
                      </div>
                      {/*End::Form Group Witness Email/phone*/}
                      {/*Begin::Form Group Sign Type*/}
                      <div className='fv-row mb-3 ml-8'>
                        <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                          <span className='required'>Sign Type</span>
                          <i
                            className='fas fa-exclamation-circle ms-2 fs-7'
                            data-bs-toggle='tooltip'
                            title='Enter sign type'
                          ></i>
                        </label>
                        <select
                          type='text'
                          className='form-select form-select-solid'
                          name={`witness[${index}].sign_type`}
                          placeholder='Enter sign type'
                          {...formik.getFieldProps(`witness[${index}].sign_type`)}
                        >
                          <option className='bg-color-gray' value='' disabled>
                            Select sign type
                          </option>
                          <option value='Electronic'>Electronic</option>
                          <option value='Aadhaar'>Aadhaar</option>
                        </select>
                        <div className='h-20px'>
                          {formik.touched.witness &&
                            formik.touched.witness[index] &&
                            formik.touched.witness[index].sign_type &&
                            formik.errors.witness &&
                            formik.errors.witness[index] &&
                            formik.errors.witness[index].sign_type && (
                              <div className='fv-help-block color-red'>
                                {formik.errors.witness[index].sign_type}
                              </div>
                            )}
                        </div>
                      </div>
                      {/*End::Form Group Sign Type*/}
                      {/*Begin::Form Group reason*/}
                      <div className='fv-row mb-3 ml-8'>
                        <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                          <span className='required'>Reason</span>
                          <i
                            className='fas fa-exclamation-circle ms-2 fs-7'
                            data-bs-toggle='tooltip'
                            title='Enter reason'
                          ></i>
                        </label>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          name={`witness[${index}].reason`}
                          placeholder='Enter reason'
                          {...formik.getFieldProps(`witness[${index}].reason`)}
                        />
                        <div className='h-20px'>
                          {formik.touched.witness &&
                            formik.touched.witness[index] &&
                            formik.touched.witness[index].reason &&
                            formik.errors.witness &&
                            formik.errors.witness[index] &&
                            formik.errors.witness[index].reason && (
                              <div className='fv-help-block color-red'>
                                {formik.errors.witness[index].reason}
                              </div>
                            )}
                        </div>
                      </div>
                      {/*End::Form Group Signer reason*/}
                    </div>
                  </div>
                </div>
              )
            })}
            {/* Begin: Add witness button */}
            <div className='col-lg-6 mb-5'>
              <button
                type='button'
                className={`d-flex align-items-center py-2 px-4 rounded btn ${
                  witness.length >= 2 ? 'btn-secondary' : 'btn-primary'
                }`}
                onClick={handleAddWitness}
                disabled={witness.length >= 2}
              >
                <span>
                  <i className='bi bi-plus-circle fs-2 text-light pt-2'></i>
                </span>
                <span className='text-light'>
                  {witness.length > 0 ? 'Add more witness' : 'Add witness'}
                </span>
              </button>
              <p className='text-muted fw-bold mb-0 px-3'>{`${witness.length}/2 ${
                witness.length <= 1 ? 'Witness' : 'Witnesses'
              } added`}</p>
            </div>
            {/* End: Add witness button */}
          </div>
        </div>
        {/* End: Witness */}
      </div>
    </div>
  )
}
export default CreateAgreementStep3
